import _ from "lodash";
import { computed } from "mobx";
import { useMemo } from "react";
import { usePipedriveStore, useSaleCompStore } from "..";

export default function (ownerFilter: string, searchFilter: string, sortBy: string) {
    const saleCompStore = useSaleCompStore();
    const pipedriveStore = usePipedriveStore();

    const ownerFilteredSaleComps = useMemo(() => computed(() => {
        switch (ownerFilter) {
            case "All Owners":
                return saleCompStore.saleComps;
            case "None":
                return saleCompStore.saleComps.filter(sc => !sc.modifiedByUser);
            default:
                return saleCompStore.saleComps.filter(sc => sc.modifiedByUser === ownerFilter);
        }
    }), [ownerFilter]).get();

    const sortedSaleComps = useMemo(() => {
        switch (sortBy) {
            case SaleCompsSortingType.ModifiedNewest:
                return _.orderBy(ownerFilteredSaleComps, saleComp => saleComp.modifiedDate, "desc");
            case SaleCompsSortingType.ModifiedOldest:
                return _.orderBy(ownerFilteredSaleComps, saleComp => saleComp.modifiedDate, "asc");
            default:
                return _.orderBy(ownerFilteredSaleComps, saleComp => saleComp.modifiedDate, "asc");
        }
    }, [ownerFilteredSaleComps, sortBy]);

    return useMemo(() => {
        if (!searchFilter)
            return sortedSaleComps;

        const searchFilterInLowerCase = searchFilter.toLowerCase();

        return sortedSaleComps.filter(sc =>
            (sc.address && sc.address.toLowerCase().includes(searchFilterInLowerCase)) ||
            (sc.pipedriveBuyerId && pipedriveStore.organizations.find(o => o.id === sc.pipedriveBuyerId)?.name.toLowerCase().includes(searchFilterInLowerCase)) ||
            (sc.pipedriveSellerId && pipedriveStore.organizations.find(o => o.id === sc.pipedriveSellerId)?.name.toLowerCase().includes(searchFilterInLowerCase)) ||
            (sc.zoning && sc.zoning.toLowerCase().includes(searchFilterInLowerCase)) ||
            (sc.pipedriveBrokerageId && pipedriveStore.organizations.find(o => o.id === sc.pipedriveBrokerageId)?.name.toLowerCase().includes(searchFilterInLowerCase)) ||
            (sc.notes && sc.notes.toLowerCase().includes(searchFilterInLowerCase))
        );
    }, [sortedSaleComps, searchFilter]);
}

export class SaleCompsSortingType {
    static ModifiedNewest = "ModifiedNewest";
    static ModifiedOldest = "ModifiedOldest";
}